export function abrirWhatsApp(numero, mensaje) {
  if (!numero || !mensaje) {
    alert("Número o mensaje faltante");
    return;
  }

  // Limpia número: sin espacios, guiones, paréntesis
  const cleanNumber = numero.replace(/[^0-9]/g, "");

  // Detectar si es móvil o escritorio
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  // Usar el link adecuado
  const urlBase = isMobile
    ? `https://wa.me/${cleanNumber}`
    : `https://web.whatsapp.com/send?phone=${cleanNumber}`;

  const fullUrl = `${urlBase}&text=${encodeURIComponent(mensaje)}`;

  window.open(fullUrl, "_blank");
}
